export const linkMatcher = /\[([^|]+)\|([^\]]+)]/g;

export const removeLinks = (value: string): string => String(value).replace(linkMatcher, '$1');

